export default __webpack_public_path__ + "static/media/surprise.8b954c0a.svg";